import { render, staticRenderFns } from "./PromotionsTable.vue?vue&type=template&id=ed3b1f44"
import script from "./PromotionsTable.vue?vue&type=script&lang=js"
export * from "./PromotionsTable.vue?vue&type=script&lang=js"
import style0 from "./PromotionsTable.vue?vue&type=style&index=0&id=ed3b1f44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports